import React, { Component } from 'react';
// styles: home.styl

class Menu extends Component {
  toggleMenu() {
    const hamburger = document.querySelector('.nav-hamburger');
    const menu = document.querySelector('.menu');
    const links = document.querySelectorAll('.menu a');

    hamburger.classList.toggle('nav-hamburger-open');
    menu.classList.toggle('menu-open');
    links.forEach((link) => {
      link.classList.toggle('link-open');
    });
  }
  render() {
    return (
      <div className='menu'>
          <div className='layer'></div>

          <a href='#our-story' onClick={this.toggleMenu}>Our Story</a>
          <a href='#our-values' onClick={this.toggleMenu}>Our Values & Mission</a>
          <a href='#our-model' onClick={this.toggleMenu}>Our Model</a>
          <a href='#our-services' onClick={this.toggleMenu}>Spectrum of Services</a>
          <a href='#highlighted-projects' onClick={this.toggleMenu}>Highlighted Projects</a>
          <a href='#team' onClick={this.toggleMenu}>Meet the Team</a>
          <a href='#contact-us' onClick={this.toggleMenu}>Contact Us</a>
      </div>
    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/menu.js